const React = require("react");
function IconPause(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 20q-.96255 0-1.6479-.6714-.6855-.6714-.6855-1.6143V6.28571c0-.62857.2285-1.16666.6855-1.61428Q15.70415 4 16.6667 4q.9624 0 1.6479.67143c.4569.44762.6854.98571.6854 1.61428V17.7143c0 .6286-.2285 1.1667-.6854 1.6143Q17.6291 20 16.6667 20m-9.33337 0c-.64166 0-1.19097-.2238-1.64791-.6714C5.22847 18.881 5 18.3429 5 17.7143V6.28571c0-.62857.22847-1.16666.68542-1.61428C6.14236 4.22381 6.69167 4 7.33333 4c.64167 0 1.19098.22381 1.64792.67143s.68542.98571.68542 1.61428V17.7143c0 .6286-.22848 1.1667-.68542 1.6143S7.975 20 7.33333 20"
  }));
}
module.exports = IconPause;